module.exports = "<div class=\"discount-line-items\"> <div class=\"order-totals-line-item__title\">Discount:</div> <div ng-repeat=\"discount in $ctrl.discounts\"> <volt-promo-code-line-item discount=\"discount\" hide-remove-button=\"!discount.discountCode\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\"/> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/newCheckout/components/orderSummary/components/discountLineItems/discountLineItems.html
// module id = 924
// module chunks = 0